import React, { useState, useContext, useEffect } from 'react';
import MetaTags from 'react-meta-tags';
import { CompanyContext } from '../../global_setting/Store';
import config from '../../../src/config.json'
import { Link } from 'react-router-dom'
import Header from './Header'
import Footer from './Footer'
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker
} from "react-google-maps";
import { compose, withProps } from "recompose";
import FooterFixed from './FooterFixed'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import _debounce from 'lodash.debounce'
import { DateRangePicker } from 'react-dates';
import moment from 'moment'
import CustomFooterSection from './sections/CustomFooterSection';


function HotelsPage() {

    var hotel_name_url;
    hotel_name_url = window.location.pathname;
    hotel_name_url = hotel_name_url.replace(config.PATH, "");

    const [companyDetails] = useContext(CompanyContext);
    let company_id_val = companyDetails && companyDetails.company_id;
    const [hotelsPageData, setHotelsPageData] = useState();

    useEffect(() => {
        (async function () {
            try {
                if (company_id_val) {
                    let company_id = companyDetails.company_id
                    let template_id = companyDetails.template_id
                    let name_hotel;
                    let hotel_id;
                    let all_hotel_rooms = []
                    let room_data = [];
                    let hotel_data;
                    let nearby_data;
                    let facilities_data;
                    const pageData = await fetch(
                        config.apiEndpoint + '/wb-frontview/get-frontview-hotel-page-data/' + company_id + '/' + template_id
                    );
                    const result = await pageData.json();

                    if (result && result.hotel_details) {
                        for (let i = 0; i < result.hotel_details.length; i++) {
                            name_hotel = result.hotel_details[i].hotel_name.replace(/[^a-zA-Z ]/g, "");
                            name_hotel = name_hotel.replace(/ +/g, "_");
                            name_hotel = name_hotel.replace(",", "");
                            name_hotel = name_hotel.toLowerCase();
                            if (hotel_name_url === name_hotel) {
                                hotel_id = result.hotel_details[i].hotel_id
                                hotel_data = result.hotel_details[i]
                            }
                        }
                    }

                    if (result && result.room_details.data) {
                        for (var i = 0; i < result.room_details.data.length; i++) {
                            for (var j = 0; j < result.room_details.data[i].length; j++) {
                                all_hotel_rooms.push(result.room_details.data[i][j]);
                            }
                        }
                    }

                    if (result && all_hotel_rooms && hotel_id) {
                        for (let i = 0; i < all_hotel_rooms.length; i++) {
                            if (all_hotel_rooms[i].hotel_id === hotel_id) {
                                room_data.push(all_hotel_rooms[i]);
                            }
                        }
                    }

                    if (result && result.nearby_places && hotel_id) {
                        for (let i = 0; i < result.nearby_places.length; i++) {
                            if (result.nearby_places[i].hotel_id === hotel_id) {
                                nearby_data = result.nearby_places[i];
                            }
                        }
                    }

                    if (result && result.hotel_facilities && hotel_id) {
                        for (let i = 0; i < result.hotel_facilities.length; i++) {
                            if (result.hotel_facilities[i].hotel_id === hotel_id) {
                                facilities_data = result.hotel_facilities[i];
                            }
                        }
                    }

                    setHotelsPageData({ "hotel_data": hotel_data, "room_data": room_data, "room_section_data": result && result.room_section_data, "nearby_data": nearby_data, "nearby_section_data": result && result.nearby_section_data, "facilities_data": facilities_data, "facilities_section_data": result && result.facility_section_data, "contact_section_data": result && result.contact_section_data, "sub_menu": result && result.sub_menu })

                }
            } catch (e) {
                console.error(e);
            }
        })();
    }, [company_id_val])

    const [scrolled, setscroll] = useState(false)
    const [display, setDisplay] = useState('overview')
    if (scrolled === false) {
        window.scrollTo(0, 0)
    }

    window.addEventListener('scroll', function () {
        setscroll(true);
    });
    const sendData = (value) => {
        setDisplay(value);
    }

    return (
        <div >

            {(hotelsPageData === undefined) ? <div className="loader"></div> : <Header />}

            {/* {index && index == 216 &&
                    <MetaTags>
                        <meta charSet="UTF-8" />
                        <title>Best Wedding Halls & Business Hotels in Bhubaneswar</title>
                        <meta name="description" content="We provide international standard amenities with the view of your budget. We have professionals experience to Host your Wedding or to have a Business Gathering." />
                    </MetaTags>
                } */}

            {hotelsPageData && hotelsPageData.hotel_data && <SliderHotel sliderdata={hotelsPageData.hotel_data} />}

            {hotelsPageData && hotelsPageData.sub_menu && hotelsPageData.sub_menu.length > 0 && <div className="tabbing desktop-sub-menu">
                <ul className="modulelinks meetingmod hotelmode hmenulink">
                    {hotelsPageData.sub_menu.map(function (item, i) {
                        return (
                            <li className="modulelink" key={i}>
                                <div className={(display === item.section_name) ? "nav active" : 'nav'} onClick={() => sendData(item.section_name)}>{item.menu_name}</div>
                            </li>
                        )
                    })}
                </ul>
            </div>}

            {hotelsPageData && hotelsPageData.sub_menu && hotelsPageData.sub_menu.length > 0 && <div className="tabbing mobile-sub-menu">
                <div className="scrolling-wrapper1">
                    <ul className="modulelinks meetingmod hotelmode hmenulink">
                        {hotelsPageData.sub_menu.map(function (item, i) {
                            return (
                                <li className="modulelink card" key={i}>
                                    <div className={(display === item.section_name) ? "nav active" : 'nav'} onClick={() => sendData(item.section_name)}>{item.menu_name}</div>
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>}

            {hotelsPageData && hotelsPageData.hotel_data && <DatePickerWidget hoteldata={hotelsPageData.hotel_data} companyDetails={companyDetails}/>}

            {hotelsPageData && hotelsPageData.hotel_data && <HotelIntroduction hoteldata={hotelsPageData.hotel_data} />}

            {hotelsPageData && hotelsPageData.hotel_data && (display === 'overview') && <OverView data={hotelsPageData} />}
            {hotelsPageData && hotelsPageData.room_data && (display === 'rooms') && <RoomHotel roomdata={hotelsPageData.room_data} room_section_data={hotelsPageData.room_section_data} />}
            {hotelsPageData && hotelsPageData.facilities_data && (display === 'services') && <FacilitiesHotel facilitiesdata={hotelsPageData.facilities_data} facilities_section_data={hotelsPageData.facilities_section_data} />}
            {hotelsPageData && hotelsPageData.hotel_data && (display === 'reach') && <ContactHotel contactdata={hotelsPageData.hotel_data} contact_section_data={hotelsPageData.contact_section_data} />}
            {hotelsPageData && hotelsPageData.nearby_data && (display === 'location') && <LocationHotel locationdata={hotelsPageData.nearby_data} location_section_data={hotelsPageData.nearby_section_data} hoteldata={hotelsPageData.hotel_data} />}
            {hotelsPageData && <CustomFooterSection />}
            {hotelsPageData && <FooterFixed />}
        </div>
    )
}

function HotelIntroduction(props) {
    let hotel_data = props.hoteldata;
    return (
        <div>
            {hotel_data && <div className="container">
                <div className="explor_title row m0">
                    <div className="pull-left">
                        <div className="center_title">
                            <h2>{hotel_data.hotel_name}</h2>
                        </div>
                    </div>
                </div>
                <div className="contact_info_list">
                    <div className="media">
                        <div className="media-left">
                            <i className="fa fa-map-marker"></i>
                        </div>
                        <div className="media-body">
                            <p>{hotel_data.hotel_address}</p>
                        </div>
                        <div className="media">
                            <div className="media-left">
                                <i className="fa fa-phone"></i>
                            </div>
                            <div className="media-body">
                                <p>{hotel_data.mobile}</p>

                            </div>
                        </div>
                    </div>
                </div>
                <br />
                <p dangerouslySetInnerHTML={{ __html: hotel_data.hotel_description }}></p>
            </div>}
        </div>
    )
}

function OverView(props) {
    let hotelsPageData = props.data;

    return (
        <div>
            {hotelsPageData && <div>
                <RoomHotel roomdata={hotelsPageData.room_data} room_section_data={hotelsPageData.room_section_data} />
                <FacilitiesHotel facilitiesdata={hotelsPageData.facilities_data} facilities_section_data={hotelsPageData.facilities_section_data} />
                <LocationHotel locationdata={hotelsPageData.nearby_data} location_section_data={hotelsPageData.nearby_section_data} hoteldata={hotelsPageData.hotel_data} />
            </div>}
        </div>
    )
};



function RoomHotel(props) {
    let room_section_data = props.room_section_data
    let room_data = props.roomdata
    return (
        <div>
            <section className="explor_room_area explore_room_list">
                <div className="container">
                    <div className="explor_title row m0">
                        <div className="pull-left">
                            {room_section_data && <div className="center_title">
                                <h2>{room_section_data.section_title}</h2>
                                <p dangerouslySetInnerHTML={{ __html: room_section_data.section_description }}></p>
                            </div>}
                        </div>
                    </div>
                    <div className="row explor_room_item_inner">

                        {room_data && room_data.map(function (item, i) {
                            let send_room_type = item.room_type.replace(/[^a-zA-Z ]/g, "");
                            send_room_type = send_room_type.replace(/ +/g, "_");
                            send_room_type = send_room_type.toLowerCase();
                            return (
                                <div className="col-md-4 col-sm-6" key={i}>
                                    <div className="explor_item">

                                        <OwlCarousel
                                            className="owl-theme"
                                            items={1}
                                            autoplay={true}
                                            autoplaySpeed={950}
                                            loop
                                            nav

                                        >
                                            {item.room_image.map(function (items, i) {
                                                return (
                                                    <div className="item" key={i}>
                                                        <div className="dotts">
                                                            <Link className="room_image" to={{
                                                                pathname: config.PATH + '' + send_room_type,
                                                            }}>
                                                                <img src={config.imageEndpoint + '/' + items} alt="" style={{ height: 235, width: "100%" }}/>
                                                            </Link>
                                                        </div>
                                                    </div>
                                                )
                                            })}
                                        </OwlCarousel>

                                        <div className="explor_text">
                                            <Link to={{
                                                pathname: config.PATH + '' + send_room_type,
                                            }}>
                                                <div className="explore-room-info">{item.room_type}</div>
                                            </Link>
                                            <div className="text-center">
                                                <div className="card-room">
                                                    <div className="text-center"><i className="fa fa-search"></i></div>
                                                    <span>{item.room_view_type}</span>
                                                </div>
                                                <div className="card-room">
                                                    <div className="text-center"><i className="fa fa-bed" ></i></div>
                                                    <span>{item.bed_type}</span>
                                                </div>
                                                <div className="card-room">
                                                    <div className="text-center"><i className="fa fa-window-maximize" ></i></div>
                                                    <span>{item.room_size_value} {item.room_size_unit}</span>
                                                </div>
                                            </div>
                                            <br />
                                            <div className="explor_footer">

                                                <div className="text-center">
                                                    <Link className="book_now_btn" to={{
                                                        pathname: config.PATH + '' + send_room_type,
                                                    }}>View details</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )
                        })
                        }
                    </div>
                </div>
            </section>
        </div>
    );
}

const MyMapComponent = compose(
    withProps({
        googleMapURL:
            "https://maps.googleapis.com/maps/api/js?key=AIzaSyAvbN2yXDGSnDIMmUp9JByD39hIsJhDKok&v=3.exp&libraries=geometry,drawing,places",
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ height: `400px` }} />,
        mapElement: <div style={{ height: `100%` }} />
    }),
    withScriptjs,
    withGoogleMap
)(props => (
    <GoogleMap defaultZoom={8} defaultCenter={{ lat: props.lat, lng: props.lng }}>
        {props.isMarkerShown && (
            <Marker position={{ lat: props.lat, lng: props.lng }} />
        )}
    </GoogleMap>
));



function FacilitiesHotel(props) {
    let facilities_section_data = props.facilities_section_data
    let facilities_data = props.facilitiesdata

    return (
        <div className="container">
            <div className="room_service_list">
                {facilities_section_data && <h3 className="room_d_title">{facilities_section_data.section_title}</h3>}
                <div className="row room_service_list_inner">
                    <div className="col-sm-5 col-md-offset-right-1">
                        <div className="resot_list">
                            <ul>
                                {facilities_data && facilities_data.facilities && facilities_data.facilities.map(function (item, i) {
                                    if (i % 2 === 0) {
                                        return (
                                            <li key={i}><a><i className="fa fa-caret-right" aria-hidden="true"></i>{item}</a></li>
                                        )
                                    }
                                })}
                            </ul>
                        </div>
                    </div>
                    <div className="col-sm-5 col-md-offset-right-1">
                        <div className="resot_list">
                            <ul>
                                {facilities_data && facilities_data.facilities && facilities_data.facilities.map(function (item, i) {
                                    if (i % 2 !== 0) {
                                        return (
                                            <li key={i}><a><i className="fa fa-caret-right" aria-hidden="true"></i>{item}</a></li>
                                        )
                                    }
                                })}
                            </ul>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

function ContactHotel(props) {

    let contact_section_data = props.contact_section_data
    let contact_data = props.contactdata

    const [name, setname] = useState('');
    const [validname, setvalidname] = useState(false);
    const [requiredname, setrequiredname] = useState(false);
    const [email, setemail] = useState('');
    const [validemail, setvalidemail] = useState(false);
    const [requiredemail, setrequiredemail] = useState(false);
    const [number, setnumber] = useState('');
    const [validnumber, setvalidnumber] = useState(false);
    const [requirednumber, setrequirednumber] = useState(false);
    const [message, setmessage] = useState('');
    const [successmsg, setsuccessmsg] = useState(false)

    let numbers = [];
    let emails = [];
    if (contact_data) {
        numbers = contact_data.mobile.split(',');
        emails = contact_data.email_id.split(',');
    }

    let hotel_id = contact_data && contact_data.hotel_id

    const contactform = () => {

        if (name.length === 0) {
            setrequiredname(true)
        }
        else {
            setrequiredname(false)
        }
        if (email.length === 0) {
            setrequiredemail(true)
        }
        else {
            setrequiredemail(false)
        }
        if (number.length === 0) {
            setrequirednumber(true)
        }
        else {
            setrequirednumber(false)
        }
        if (name.length !== 0 && email.length !== 0 && number.length !== 0) {
            setrequiredname(false)
            setrequiredemail(false)
            setrequirednumber(false)
            fetch(config.apiEndpoint + '/userwb/send-user-query',
                {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        "hotel_id": hotel_id,
                        "name": name,
                        "email": email,
                        "mobile": number,
                        "message": message

                    })
                })
                .then((response) => response.json())
                .then((responseJson) => {
                    setsuccessmsg(true)
                })

            fetch(config.apiEndpoint + '/insert-customer-data',
                {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        "hotel_id": hotel_id,
                        "user_name": name,
                        "user_email_id": email,
                        "user_contact_number": number,
                        "user_message": message
                    })
                })
                .then((response) => response.json())
                .then((responseJson) => {
                })

        }


    }

    const validateName = (name) => {
        setname(name)
        if (name.match(/[A-Za-z]{2,}/)) {
            setvalidname(false)
        }
        else {
            setvalidname(true)
        }


    }
    const validateEmail = (email) => {
        setemail(email)
        if (email.match(/[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/)) {
            setvalidemail(false)
        }
        else {
            setvalidemail(true)
        }
    }
    const validateNumber = (number) => {
        setnumber(number)
        if (number.match(/^(\+\d{1,2}\s?)?1?\-?\.?\s?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/)) {
            setvalidnumber(false)
        }
        else {
            setvalidnumber(true)
        }
    }
    const validateMessage = (message) => {
        setmessage(message)
    }

    return (
        <div>
            <section className="get_contact_area">
                <div className="container">
                    <div className="row get_contact_inner">
                        <div className="col-md-6">
                            <div className="left_ex_title">
                                {contact_section_data && <h2>{contact_section_data.section_title}</h2>}
                            </div>
                            <form className="contact_us_form row m0" action='' >

                                <div className="form-group col-md-12">
                                    <input type="text" className="form-control" id="name" name="name" placeholder="Name" value={name} onChange={(e) => validateName(e.target.value)} />
                                    <div hidden={validname === false} style={{ color: 'red' }}>Invalid Name</div>
                                    <div hidden={requiredname === false} style={{ color: 'red' }}>Required</div>
                                </div>
                                <div className="form-group col-md-12">
                                    <input type="email" className="form-control" id="email" name="email" placeholder="Email" value={email} onChange={(e) => validateEmail(e.target.value)} />
                                    <div hidden={validemail === false} style={{ color: 'red' }}>Invalid Email</div>
                                    <div hidden={requiredemail === false} style={{ color: 'red' }}>Required</div>

                                </div>
                                <div className="form-group col-md-12">
                                    <input type="text" className="form-control" id="number" name="number" placeholder="Phone no." value={number} onChange={(e) => validateNumber(e.target.value)} />
                                    <div hidden={validnumber === false} style={{ color: 'red' }}>Invalid Number</div>
                                    <div hidden={requirednumber === false} style={{ color: 'red' }}>Required</div>

                                </div>
                                <div className="form-group col-md-12">
                                    <textarea className="form-control" name="message" id="message" rows="1" placeholder="Message" value={message} onChange={(e) => validateMessage(e.target.value)}></textarea>
                                </div>
                                <div className="form-group col-md-12">
                                    <div hidden={successmsg === false} style={{ color: 'red', fontSize: 15, fontWeight: 'bold' }}>Submitted Successfully !</div>
                                    <br /><br />
                                    <button type="button" className="submit_btn form-control"
                                        onClick={() => contactform()} style={{ color: "#0000000" }}>submit now</button>
                                </div>
                            </form>
                        </div>
                        <div className="col-md-6">
                            <div className="right_contact_info">
                                <div className="contact_info_list">
                                    <div className="media">
                                        <div className="media-left">
                                            <i className="fa fa-map-marker"></i>
                                        </div>
                                        <div className="media-body">
                                            <p>{contact_data && contact_data.hotel_address}</p>
                                        </div>
                                    </div>
                                    <div className="media">
                                        <div className="media-left">
                                            <i className="fa fa-phone"></i>
                                        </div>
                                        <div className="media-body">

                                            {numbers.map(function (items, i) {
                                                return (
                                                    <p key={i}><a href={"tel:" + items}>{items}</a></p>
                                                )
                                            })}

                                        </div>
                                    </div>
                                    <div className="media">
                                        <div className="media-left">
                                            <i className="fa fa-envelope-o"></i>
                                        </div>
                                        <div className="media-body">

                                            {emails.map(function (items, i) {
                                                return (
                                                    <p key={i}><a href={"mailto:" + items}>{items}</a></p>
                                                )
                                            })}
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </div>
    )
}

function DatePickerWidget(props) {

    let hotel_data = props.hoteldata
    let companyDetails = props.companyDetails;

    const [focusedInput, setfocusedInput] = useState(null)
    const [fromdate, setFromDate] = useState(moment())
    const [todate, setToDate] = useState(moment(fromdate).add(1, 'days'))
    let to_date = new Date(moment(fromdate).format('MM/DD/YYYY')).getTime();
    let from_date = new Date(moment(todate).format('MM/DD/YYYY')).getTime();
    var iframe
    let encryptData
    if (isNaN(from_date) && isNaN(to_date)) {

    }
    else {
        let allData = to_date + "|" + from_date + '|' + hotel_data.hotel_id + '|' + "" + '|' + "" + '|' + ""
        encryptData = btoa(allData);
        // iframe = encryptData

    }

    return (
        <div className="common-page">
            <div className="date-picker-wrap">
                <div className="row">
                    <div className="col-md-4 col-sm-4 form-group">
                        <label>Hotel</label>
                        <input type="text" className="form-control input-area" value={hotel_data.hotel_name} readOnly />
                    </div>
                    <div className="col-md-4 col-sm-4 form-group">
                        <DateRangePicker
                            startDate={fromdate}
                            startDateId="your_unique_start_date_id"
                            endDate={todate}
                            endDateId="your_unique_end_date_id"
                            onDatesChange={({ startDate, endDate }) => {
                                setFromDate(startDate)
                                setToDate(endDate)
                            }}
                            focusedInput={focusedInput}
                            onFocusChange={focusedInput => setfocusedInput(focusedInput)}
                            displayFormat='DD-MM-YYYY'
                            customArrowIcon="|"
                            block={true}
                        />
                    </div>

                    <div className="col-md-4 col-sm-4">
                        <div className="text-left date-picker-btn">
                            {/* <Link className="book_now_btn"
                                to={{
                                    pathname: config.PATH + 'booknow',
                                    search: '?' + (iframe),
                                }}
                            >Book Now</Link> */}
                        <a className="book_now_btn" href={"https://" + companyDetails.subdomain_name +"/property?q="+encryptData}>Book Now</a>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

function SliderHotel(props) {
    let slider_data = props.sliderdata
    return (
        <div className="container-fluid common-page slider-common" style={{ padding: "0px", margin: "0px" }}>
            <OwlCarousel
                className="owl-theme"
                items={1}
                autoplay={true}
                autoplaySpeed={950}
                loop
                nav
                play={5000, 5000}
                autoWidth={false}
            >
                {slider_data && slider_data.image_name && slider_data.image_name.map(function (item, i) {
                    if (item !== null) {
                        return (
                            <div className="item" key={i} >
                                <img src={config.imageEndpoint + '/' + item.image_name} />
                            </div>
                        )
                    }
                })}


            </OwlCarousel>
        </div>

    )
}

function LocationHotel(props) {

    let location_section_data = props.location_section_data
    let location_data = props.locationdata
    let hotel_data = props.hoteldata


    return (
        <section className="get_contact_area places-nearby">
            <div className="container">
                <div className="explor_title row m0">
                    <div className="pull-left">
                        {location_section_data && <div className="center_title">
                            <h2>{location_section_data.section_title}</h2>
                        </div>}
                    </div>
                </div>

                {location_data && location_data.places_details && location_data.places_details.length > 0 ?
                    <div className="row get_contact_inner">
                        <div className="col-md-6">
                            {hotel_data && <div className="map_box_inner">
                                <MyMapComponent isMarkerShown
                                    lat={parseFloat(hotel_data.latitude)}
                                    lng={parseFloat(hotel_data.longitude)} />
                            </div>}
                        </div>
                        <div className="col-md-6">
                            <div className="right_contact_info nearby-places-list">
                                {location_data.places_details.map(function (item, i) {
                                    return (
                                        <div className="row" style={{ padding: "10px" }} key={i}>
                                            <div className="col-md-6 col-sm-6 col-xs-6">
                                                <div><i className="fa fa-map-marker" aria-hidden="true"></i> {item.place_name}({item.distance} km)</div>
                                            </div>
                                            <div className="col-md-6 col-sm-6 col-xs-6 mins">
                                                <div className="pull-right" style={{ marginRight: "20px" }}>{item.time} Mins Drive</div>
                                            </div>
                                        </div>
                                    )
                                })}
                            </div>
                        </div>
                    </div> :
                    <div className="row get_contact_inner">
                        <div className="col-md-12">
                            {hotel_data && <div>
                                <MyMapComponent isMarkerShown
                                    lat={parseFloat(hotel_data.latitude)}
                                    lng={parseFloat(hotel_data.longitude)} />
                            </div>}
                        </div>
                    </div>
                }
            </div>
        </section>
    )

}

export default HotelsPage;